
/* SHIPPING_METHOD */
export const SELECT_SHIPPING_METHOD              = 'SELECT_SHIPPING_METHOD_ACTION'
export const SELECTING_SHIPPING_METHOD_ASYNC     = 'SELECTING_SHIPPING_METHOD_ACTION_ASYNC'
export const SHIPPING_METHODS_UPDATED            = 'SHIPPING_METHODS_UPDATED_ACTION'
/* PAYMENT_METHOD */
export const SELECT_PAYMENT_OPTION               = 'SELECT_PAYMENT_OPTION_ACTION'
export const BRAINTREEE_PAYMENT_DATA_UPDATE      = 'BRAINTREEE_PAYMENT_DATA_UPDATE_ACTION'
export const PURCHASE_ORDER_PAYMENT_DATA_UPDATE  = 'PURCHASE_ORDER_PAYMENT_DATA_UPDATE_ACTION'
/* COMPLETE CHECKOUT */
export const COMPLETE_CHECKOUT                   = 'COMPLETE_CHECKOUT_ACTION'
export const PLACE_ORDER_ASYNC                   = 'PLACE_ORDER_ASYNC_ACTION'
/* ERROR */
export const NOTIFY_ERROR                        = 'NOTIFY_ERROR_ACTION'
export const NOTIFY_COMPLETE_CHECKOUT_ERROR      = 'NOTIFY_COMPLETE_CHECKOUT_ERROR_ACTION'
export const NOTIFY_DUPLICATEPO_CHECKOUT_ERROR   = 'NOTIFY_DUPLICATEPO_CHECKOUT_ERROR_ACTION'
export const LOG_ERROR                           = 'LOG_ERROR_ACTION'
/* UI */
export const USE_BILLING_FOR_SHIPPING_TOGGLE     = 'USE_BILLING_FOR_SHIPPING_TOGGLE_ACTION'
export const DISMISS_MESSAGE                     = 'DISMISS_MESSAGE_ACTION'
export const SHIPPING_METHODS_ARE_VALID          = 'SHIPPING_METHODS_ARE_VALID_ACTION'
/* CART */
export const UPDATE_ITEM_QUANTITY                = 'UPDATE_ITEM_QUANTITY'
export const DELETE_ITEM                         = 'DELETE_ITEM'
export const UPDATING_ITEM_QUANTITY_ASYNC        = 'UPDATING_ITEM_QUANTITY_ASYNC'
export const DELETING_ITEM_ASYNC                 = 'DELETING_ITEM_ASYNC'
export const UPDATE_ORDER_TYPE                   = 'UPDATE_ORDER_TYPE_ACTION'
export const UPDATE_ORDER_TYPE_ASYNC             = 'UPDATE_ORDER_TYPE_ASYNC_ACTION'
export const UPDATING_CART_ITEMS_ASYNC           = 'UPDATING_CART_ITEMS_ASYNC_ACTION' 
export const UPDATE_CART_ITEMS                   = 'UPDATE_CART_ITEMS_ACTION' 

/* ADDRESS */
export const ADD_SHIPPING_ADDRESS                = 'ADD_SHIPPING_ADDRESS_ACTION'
export const ADD_BILLING_ADDRESS                 = 'ADD_BILLING_ADDRESS_ACTION'
export const REMOVE_SHIPPING_ADDRESS             = 'REMOVE_SHIPPING_ADDRESS_ACTION'
export const REMOVE_BILLING_ADDRESS              = 'REMOVE_BILLING_ADDRESS_ACTION'
export const UPDATE_ADDRESS                      = 'UPDATE_ADDRESS_ACTION'
export const SELECT_BILLING_ADDRESS              = 'SELECT_BILLING_ADDRESS_ACTION'
export const SELECT_SHIPPING_ADDRESS             = 'SELECT_SHIPPING_ADDRESS_ACTION'
export const SELECTING_BILLING_ADDRESS_ASYNC     = 'SELECTING_BILLING_ADDRESS_ACTION_ASYNC'
export const 
  SELECTING_SHIPPINGANDBILLING_ADDRESS_ASYNC     = 'SELECTING_SHIPPINGANDBILLING_ADDRESS_ACTION_ASYNC'
export const SELECTING_SHIPPING_ADDRESS_ASYNC    = 'SELECTING_SHIPPING_ADDRESS_ACTION_ASYNC'
export const SAVE_ADDRESS_ASYNC                  = 'SAVE_ADDRESS_ASYNC_ACTION'
export const DELETE_ADDRESS_ASYNC                = 'DELETE_ADDRESS_ASYNC_ACTION'
export const SELECT_SHIPPING_AND_BILLING_ADDRESS = 'SELECT_BILLING_AND_SHIPPING_ADDRESS_ACTION'

/* SUMMARY */
export const UPDATING_SUMMARY_ASYNC              = 'UPDATING_SUMMARY_ASYNC_ACTION'
export const UPDATED_SUMMARY                     = 'UPDATED_SUMMARY_ACTION'

/* Coupon */
export const UPDATE_COUPON                       = 'UPDATE_COUPON_ACTION'
export const UPDATE_COUPON_ASYNC                 = 'UPDATE_COUPON_ASYNC_ACTION'
export const REMOVE_COUPON                       = 'REMOVE_COUPON'
export const REMOVE_COUPON_ASYNC                 = 'REMOVE_COUPON_ACTION'
export const UPDATATING_COUPON_ASYNC             = 'UPDATATING_COUPON_ASYNC'

export const UPDATE_ANONYMOUS_USER_EMAIL         = 'UPDATE_ANONYMOUS_USER_EMAIL_ACTION'
export const UPDATE_ANONYMOUS_USER_EMAIL_ASYNC   = 'UPDATE_ANONYMOUS_USER_EMAIL_ASYNC_ACTION'
export const REMOVE_ANONYMOUS_USER_EMAIL         = 'REMOVE_ANONYMOUS_USER_EMAIL_ACTION'
export const REMOVE_ANONYMOUS_USER_EMAIL_ASYNC   = 'REMOVE_ANONYMOUS_USER_EMAIL_ASYNC_ACTION'

export const PO_NUMBER_CHANGE                    = 'PO_NUMBER_CHANGE_ACTION'


// WEBPACK FOOTER //
// ./src/Components/checkout/GlobalStateContainer/actions.js